import * as React from "react";
import classnames from "classnames";
import { H4 } from "@grandvisionhq/iris-ui";
import { DonationSummary } from "@grandvisionhq/lib-visuals";
import { useIntl } from "@grandvisionhq/state";
import { formatPrice } from "@grandvisionhq/utils";
/* empty css             */
import { TotalsContainer } from "../../../Totals/containers/modules/Totals/containers/TotalsContainer.js";
import { NavigationContainer } from "../../components/navigation/modules/Summary/components/navigation/NavigationContainer.js";
import { useCart } from "../../../../context/Cart/context/Cart/context.js";
const Summary = ({
  donationAmount,
  handleCheckoutNavigation,
  hasSubscription,
  isReadOnly,
  selectedPaymentMethodPrice,
  summaryLabel,
  unavailableLineItems
}) => {
  const { locale, currency, getLabel, getFormattedLabel } = useIntl();
  const { cart } = useCart();
  return /* @__PURE__ */ React.createElement("section", { className: classnames("cart-summary", { "cart-summary--read-only": isReadOnly }) }, /* @__PURE__ */ React.createElement(
    H4,
    {
      className: "cart-summary__heading",
      variant: "heading-smallest",
      "aria-hidden": isReadOnly ? "true" : void 0
    },
    summaryLabel
  ), /* @__PURE__ */ React.createElement(TotalsContainer, { selectedPaymentMethodPrice }), donationAmount && /* @__PURE__ */ React.createElement(
    DonationSummary,
    {
      label: getLabel("checkout.payment.donation.summary.title"),
      formattedDonationAmount: formatPrice({
        locale,
        value: donationAmount,
        currency,
        isCentAmount: true
      }),
      disclaimer: getFormattedLabel("checkout.payment.donation.summary.description", {
        labelData: {
          total: formatPrice({
            locale,
            value: (cart?.prices.totalPrice ?? 0) + donationAmount,
            currency,
            isCentAmount: true
          }),
          cartTotal: formatPrice({
            locale,
            value: cart?.prices.totalPrice,
            currency,
            isCentAmount: true
          }),
          donationTotal: formatPrice({
            locale,
            value: donationAmount,
            currency,
            isCentAmount: true
          })
        }
      })
    }
  ), !isReadOnly && /* @__PURE__ */ React.createElement("div", { className: "cart-summary__navigation" }, /* @__PURE__ */ React.createElement(
    NavigationContainer,
    {
      handleCheckoutNavigation,
      hasSubscription,
      unavailableLineItems
    }
  )));
};
export {
  Summary
};
//# sourceMappingURL=Summary.js.map
